export const SITE = {
  company: "Everstone Roofing",
  legalName: "Everstone Roofing Inc",
  city: "Milwaukee, WI",
  phone: "(414) 441-4143",
  email: "everstoneroofing@gmail.com",
  address: "Franklin, WI 53132",
  license: "WI License #5492-DCQ",
  gafStatus: "2026 GAF Certified™ Residential Roofing Contractor",
  positioning:
    "We specialize in roofing, gutters, siding, soffit, fascia, and exterior storm restoration.",
  // --- Social links ---
  social: {
    facebook: "https://www.facebook.com/share/1CZXEoPhHt/",
    google: "https://maps.app.goo.gl/pjFSEc6EzWjjcA2k7",
    linkedin: "https://www.linkedin.com/in/everstone-roofing-5528a6445",
  },
  gafId: "7159156",
  googleReviewsUrl: "https://maps.app.goo.gl/pjFSEc6EzWjjcA2k7",
  googleLeaveReviewUrl: "https://maps.app.goo.gl/pjFSEc6EzWjjcA2k7", // TODO: replace with g.page/r/... short link when provided
  googleRating: "5.0", // all current Google reviews are 5 stars — review count intentionally not shown
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/9d5f7b0a6b127502bbe45c81b9df6b35f51e1b5335f9c96b9d95f53f7d136ff0.png",
  roofing: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/772f2c12215047f55c3ea5297ce46023b954439bb8c6c7cfe0c8342d39e404a8.png",
  gutters: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/683e8164d494683c08c09692b5f4b3ace22a3e5e1798bb4ec04d918677299352.png",
  stormDamage: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/93a1935c43b05a29ef07bd174c80aad127b1c32713259c6d4696b722d032f9da.png",
  siding: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/fa5b714c51324fc42e44df1ddf8d4f301186924e59cd9efab5d4de733c0a9311.png",
  soffitFascia: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/d102ab04183a9b18465875ced192909993cd79dd46e18990f69082e45ee5b1b4.png",
  crew: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/b53780c20f85d73374f29339c7fa321cf2a0b2c58da866abcaa0a78b1c5dc71e.png",
  wideJobsite: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/7fdcdeb81d0781173430b485e98b30334a3f37223eed2e393f7ad994b6f2afd0.png",
  beforeAfter1: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/bd46223925881100860f57afdd733c6a05aeffd91b69a9bf4129e7825ddf9ad9.png",
  beforeAfter2: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/fe43c136343e6bb48519aac838fd5272b1e8b9816600784ffffe7077a481f831.png",
  texture: "https://static.prod-images.emergentagent.com/jobs/37ecafff-54c9-44a6-a491-481dcbb163bd/images/8cfec722de7843c98df5c25291c397b765366e39b64bd2deaee231cace91eff2.png",
  // Official GAF Certified badge — file used exactly as provided by the owner
  gafBadge: "/assets/gaf-badge.jpeg",
  gafCertificate: "/assets/gaf-certificate.jpg",
  wiLicense: "/assets/wi-license-redacted.png",
};

export const SERVICES = [
  {
    key: "roofing",
    title: "Roof Replacement",
    image: IMAGES.roofing,
    desc: "Full tear-offs and architectural shingle systems built for snow load, ice dams, and Great Lakes freeze-thaw.",
    points: [
      "Architectural & impact-rated shingle options",
      "Full ice & water shield at eaves and valleys",
      "Complete GAF roofing system — GAF System Plus Limited Warranty available",
      "Metal valleys on every roof — standard, not an upgrade",
      "Pipe boots included in the base package",
    ],
  },
  {
    key: "storm",
    title: "Storm & Hail Damage",
    image: IMAGES.stormDamage,
    desc: "Storm damage inspections done right. We identify hidden hail and wind damage, document everything clearly, and help homeowners move fast before leaks turn into structural problems.",
    points: [
      "Detailed hail & wind damage documentation",
      "Direct insurance claim assistance",
      "Fast turnaround — before leaks become structural",
    ],
  },
  {
    key: "gutters",
    title: "Gutters & Downspouts",
    image: IMAGES.gutters,
    desc: "Seamless aluminum gutters and downspouts sized to your roof — installed clean, sealed properly, color-matched to the fascia.",
    points: [
      "Seamless runs in 5\" and 6\" K-style",
      "Hidden-hanger installation",
      "Leaf guards built for Wisconsin oaks and maples",
    ],
  },
  {
    key: "siding",
    title: "Siding",
    image: IMAGES.siding,
    desc: "Vinyl, engineered wood, and fiber-cement siding installed with proper house wrap, flashing details, and a clean finish line.",
    points: [
      "Vinyl, LP SmartSide, and James Hardie systems",
      "Tyvek house wrap & flashing integration",
      "Trim, J-channel, and corner detail done right",
    ],
  },
  {
    key: "soffit",
    title: "Soffit & Fascia",
    image: IMAGES.soffitFascia,
    desc: "Aluminum soffit and fascia that finishes the roofline, protects the eaves, and ventilates the attic the way it should.",
    points: [
      "Vented aluminum soffit for proper attic airflow",
      "Color-matched fascia covers",
      "Cleanup, caulk, and trim included",
    ],
  },
];

// 8 trust points — GAF first, then updated Licensed & Insured
export const TRUST_POINTS = [
  { label: "GAF Certified Contractor", desc: "Certified by GAF, North America's largest roofing manufacturer. Every Everstone roof is a complete GAF system — eligible for the GAF System Plus Limited Warranty." },
  { label: "Licensed & Insured", desc: "Wisconsin licensed (DCQ #5492-DCQ) and fully insured with general liability coverage." },
  { label: "Wisconsin-Focused Systems", desc: "Roofing & exterior systems built for snow load, ice dams, and freeze-thaw." },
  { label: "Storm & Hail Specialists", desc: "Post-storm inspections and direct insurance claim assistance." },
  { label: "Clean Job Sites", desc: "Tarps down, magnetic nail sweeps, debris hauled — twice." },
  { label: "Architectural Shingles", desc: "Premium dimensional shingles in slate, charcoal, and weathered wood." },
  { label: "Ice & Water Shield", desc: "Full eaves & valley protection — engineered for Wisconsin winters." },
  { label: "Winter Roofing Support", desc: "Snow removal from roofs, emergency leak prevention, ice dam awareness, and cold-weather inspections for Wisconsin homes." },
];

// Real reviews only — transcribed exactly as shown on the Google Business Profile.
// Do not edit wording or grammar; add new reviews verbatim as they come in.
export const REVIEWS = [
  {
    name: "Errin Avent",
    stars: 5,
    text: "Returning customer here. they did our gutters a few years back and just finished our full roof replacement and the quality of their service have been great! I have no complaints.",
  },
  {
    name: "David Vladimirov",
    stars: 5,
    text: "Everstone Roofing replaced our gutters and did an awesome job. They look great and finally drain the way they're supposed to Would hire these guys again",
  },
  {
    name: "Saintelus Pierre",
    stars: 5,
    text: "Alex came out promptly, inspected the roof, and gave me a straight-up, fair estimate without any pushy sales pitch His team did a fantastic job, finished quickly, and cleaned up the site completely Highly recommend Alex and Everstone if you want quality work and honest service!",
  },
];

export const FAQS = [
  {
    q: "Are you licensed and insured?",
    a: "Yes. Everstone Roofing Inc holds Wisconsin DCQ license #5492-DCQ and carries general liability insurance.",
  },
  {
    q: "Are you GAF certified?",
    a: "Yes. We are a 2026 GAF Certified Residential Roofing Contractor and install complete GAF roofing systems, eligible for the GAF System Plus Limited Warranty.",
  },
  {
    q: "Is the estimate free?",
    a: "For most homes, yes. We inspect the roof in person and send a clear written estimate with no obligation. Some roofs — very steep pitch, multi-story or hard-to-access — require special safety equipment, so the inspection may be paid. If that applies to your home, we'll tell you the price upfront, before any visit.",
  },
  {
    q: "Do you help with storm and hail insurance claims?",
    a: "Yes. We document hail and wind damage with photos and help you through the insurance claim process.",
  },
  {
    q: "What is included in every roof?",
    a: "A complete GAF system, ice & water shield at eaves and valleys, metal valleys, and pipe boots — all standard.",
  },
  {
    q: "What areas do you serve?",
    a: "Franklin, Milwaukee, Waukesha, Racine, Kenosha, Ozaukee and Washington counties, Lake Geneva, and surrounding areas.",
  },
];
